import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '../registration.service';
import { Router } from '@angular/router';
import { Imagemodel } from '../imagemodel';
import { Car } from '../car';
import { User } from '../user';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-addcar',
  templateUrl: './addcar.component.html',
  styleUrls: ['./addcar.component.css']
})
export class AddcarComponent implements OnInit {
  imagemodel = new Imagemodel();
  carForm: FormGroup;

  msg = '';
  public selectedFile: File | null = null;
  imgURL: any;
  uploadedFileName: string = '';
  lastAddedCar: Car | null = null;
  submitting = false;
  maxYear = new Date().getFullYear() + 1;

  constructor(private _service: RegistrationService, private _route: Router, private _http: HttpClient, private fb: FormBuilder) {
    this.carForm = this.fb.group({
      brand: ['', Validators.required],
      model: ['', Validators.required],
      year: [null, [Validators.required, Validators.min(1900), Validators.max(this.maxYear)]],
      price: [null, [Validators.required, Validators.min(1)]],
      description: ['']
    });
  }

  ngOnInit(): void {}

  /*public onFileChanged(event:any) {
  
    this.imagemodel.selectedFile = event.target.files[0];
    }*/

  
  onUpload(){
  this._service.imageUploadfromRemote(this.imagemodel).subscribe(
    data => {console.log('Response Recived',data)
    if (data.status === 200) {
      this.msg = 'Image uploaded successfully';
      
  } else {
      
        this.msg = 'Image not uploaded successfully';
      }
   
  }
  );
}
submitCar() {
    if (this.carForm.invalid) {
      this.msg = 'Please fix validation errors.';
      return;
    }

    this.submitting = true;
    const car: Car = { ...this.carForm.value } as Car;

    const proceedAdd = (maybeImageName?: string) => {
      if (maybeImageName) { car.imageName = maybeImageName; }
      this._service.addCarFromRemote(car).subscribe(
        data => {
          this.submitting = false;
          this.lastAddedCar = car;
          this.msg = '';
          this.carForm.reset();
          this.selectedFile = null;
          this.imgURL = null;
          this.uploadedFileName = '';
          setTimeout(() => this._route.navigate(['/table-list']), 800);
        },
        error => {
          console.error('Exception occurred', error);
          this.submitting = false;
          this.msg = 'Failed to add car';
        }
      );
    };

    if (this.selectedFile) {
      this.imagemodel.selectedFile = this.selectedFile;
      this._service.imageUploadfromRemote(this.imagemodel).subscribe(
        uploadRes => {
          const imageName = (uploadRes && uploadRes.imageName) ? uploadRes.imageName : (this.selectedFile ? this.selectedFile.name : undefined);
          proceedAdd(imageName);
        },
        err => {
          console.error('Image upload failed', err);
          // still attempt to add car without image
          proceedAdd();
        }
      );
    } else {
      proceedAdd();
    }
  }
public onFileChanged(event:any) {
    this.selectedFile = event.target.files[0] || null;
    this.uploadedFileName = this.selectedFile ? this.selectedFile.name : '';

    if (this.selectedFile) {
      const reader = new FileReader();
      reader.readAsDataURL(this.selectedFile);
      reader.onload = () => {
        this.imgURL = reader.result;
      };
    } else {
      this.imgURL = null;
    }
  }
/*saveCar()
{
  if (this.car.carId== null) {

    const uploadData = new FormData();
    uploadData.append('imageFile', this.selectedFile, this.selectedFile.name);
    this.selectedFile.imageName = this.selectedFile.name;

    let tokenstr=sessionStorage.getItem('token1');
     let maintocken=''+'Bearer '+tokenstr+'';
     console.log(maintocken)
     const headers = new HttpHeaders({ Authorization: maintocken});

    this._http.post(`${environment.apiUrl}/uploadsm`, uploadData, {headers, observe: 'response' })
      .subscribe((response) => {
        if (response.status === 200) {
          this._service.addCarFromRemote(this.car).subscribe(
            (car) => {
              console.log('Succes'+car);
            }
          );
          console.log('Image uploaded successfully');
        } 
        else {
          console.log('Image not uploaded successfully');
        }
      }
    );
  }

}*/


}
